/* ###########################
##### vergleichstabelle ######
#############################*/
TablesawConfig = {
    getColumnToggleLabelTemplate: function (text) {
        return '<label><input class="colChk" type="checkbox" checked><span>' + text + '</span></label>';
    }
};

// Tablesaw.init();



/* ###########################
##### sidebar navigation ######
#############################*/
const shopHeader = document.getElementById('section-header');
const navbar = document.getElementById('sub-nav');
const navBarMob = document.querySelector('#sub-nav-mobile');
const header = document.querySelector('#header');
const mobList = document.querySelector('#sub-nav-mobile ul');
const subNavBtnMob = navBarMob.querySelector('.float-sidenav__btn2');
let navbarLinks = document.querySelectorAll('#float-sidenav-container a');

subNavBtnMob.addEventListener("click", e => {
    if (subNavBtnMob.classList.contains('nav-open')) {
        subNavBtnMob.classList.remove('nav-open')
        document.querySelector('#sub-nav-mobile').classList.add('float-sidenav__shadow');
        mobList.style.visibility = 'visible';
        // document.querySelector('#sub-nav-mobile ul.float-sidenav__label').style.display = 'none'
        subNavBtnMob.classList.add('nav-close')
    } else {
        subNavBtnMob.classList.remove('nav-close')
        mobList.style.visibility = 'hidden';
        document.querySelector('#sub-nav-mobile').classList.remove('float-sidenav__shadow');
        subNavBtnMob.classList.add('nav-open')
    }
})

const navbarToggle = (v) => {
    if (window.innerWidth > 1040) {
        navbarLinks.forEach(link => {
            let label = link.querySelector('.float-sidenav__label');

            if (v == 'show' && label.classList.contains('label-hide')) {
                label.classList.remove("label-hide");
                label.classList.add("label-" + v);
            } else {
                label.classList.remove("label-show");
                label.classList.add("label-" + v);
            }
        })
    }
};
// navbarToggle('show')

navbar.style.top = header.getBoundingClientRect().top + header.offsetHeight + 'px';
navBarMob.style.top = header.getBoundingClientRect().top + header.offsetHeight + 'px';

window.addEventListener("scroll", e => {
    let scrollPos = window.scrollY;

    // if ( (header.getBoundingClientRect().top+header.offsetHeight)+navbar.offsetHeight/2 > window.innerHeight/2 ) {
    if ((header.getBoundingClientRect().top + header.offsetHeight) > shopHeader.offsetHeight + 50) {
        navbar.style.top = header.getBoundingClientRect().top + header.offsetHeight + 'px';
        navBarMob.style.top = header.getBoundingClientRect().top + header.offsetHeight + 'px';
        // console.log('scroll')
    } else { }

    
    navbarLinks.forEach(link => {
        let section = document.querySelector(link.hash);

        if (scrollPos + 150 > section.offsetTop && scrollPos + 150 < section.offsetTop + section.offsetHeight) {
            link.classList.add("active");
        } else {
            link.classList.remove("active");
        }
    });
});
/* END sub navigation */



function noScroll() {
    window.scrollTo(0, 0);
}
window.addEventListener('scroll', noScroll);

// window.onload = function () {
addEventListener('DOMContentLoaded', () => {
    lax.init()
    // Tablesaw.init();

    // fake preloader 
    const preloadSec = document.querySelector('.preload');
    const preloader = () => {
        window.scrollTo(0, 0);
        let count = 1;
        let fadeInterval = setInterval(function () {
            count -= 0.1;
            preloadSec.style.opacity = count;
            if (count <= 0) {
                clearInterval(fadeInterval)
                window.removeEventListener('scroll', noScroll);
                preloadSec.remove()
            }
        }, 100);
    }
    const preload = setTimeout(preloader, 300);

    /* tablesaw */
    /*
    const columnChk = document.querySelectorAll('.colChk');

    function verifyCol(n, v) {
        let viewportWidth = window.innerWidth;

        switch (true) {
            case (viewportWidth < 420):
                document.querySelector('#tablesaw-hint').innerHTML = 'Durch das Setzen von bis zu <b>zwei</b> Häkchen gleichzeitig kannst du einzelne Kalender und Bundle vergleichen. Mit  einem weiteren Klick auf eines der Häkchen, lässt sich dieses auch wieder abwählen.';
                if (n > 2 && v) {
                    v.checked = false;
                }                    
                break;
            case (viewportWidth < 600):
                document.querySelector('#tablesaw-hint').innerHTML = 'Durch das Setzen von bis zu <b>drei</b> Häkchen gleichzeitig kannst du einzelne Kalender und Bundle vergleichen. Mit  einem weiteren Klick auf eines der Häkchen, lässt sich dieses auch wieder abwählen.';
                if (n > 3 && v) {
                    v.checked = false;
                }
                break;
            case (viewportWidth < 700):
                document.querySelector('#tablesaw-hint').innerHTML = 'Durch das Setzen von bis zu <b>vier</b> Häkchen gleichzeitig kannst du einzelne Kalender und Bundle vergleichen. Mit  einem weiteren Klick auf eines der Häkchen, lässt sich dieses auch wieder abwählen.';
                if (n > 4 && v) {
                    v.checked = false;
                }
        }
    };
    
    verifyCol(document.querySelectorAll('.tablesaw-btn-group input[type="checkbox"]:checked').length)
     
    columnChk.forEach((columnChk, i) => {	        
        columnChk.addEventListener('click', function() {
            let count = document.querySelectorAll('.tablesaw-btn-group input[type="checkbox"]:checked').length;

            if (count < 1) {
                this.checked = true;
            }
            verifyCol(count, this)
        }, false)
    })
    */ 


    /* ###########################
    ##### parallaxs animatons ######
    #############################*/
    // Add a driver that we use to control our animations
    lax.addDriver('scrollY', function () {
        return window.scrollY
    })

    lax.addElements('.avk-theme-moveWhale', {
        scrollY: {
            translateX: [
                ["elInY", "elOutY"],
                {
                    576: ['screenWidth-100', '-screenWidth'],
                    768: ['screenWidth+elWidth/2', '-screenWidth'],
                    1138: ['screenWidth+elWidth', '-screenWidth'],
                    // 1600: ['screenWidth+elWidth*2','-screenWidth'],
                    1600: ['screenWidth*2+elWidth', '-screenWidth'],
                }
            ],
            translateY: [
                ["elInY", "elOutY"],
                {
                    576: [0, 0],
                    768: [100, -150],
                    1138: [120, -150],
                    1600: [280, -150],
                }
            ],
            scale: [
                ["elInY", "elCenterY+100", "elOutY"],
                {
                    576: [0.2, 1.0, 0.2],
                    768: [0.2, 1.2, 0.2],
                }

            ]
        }
    })

    //  Kalender blur //
    lax.addElements('.avk-img', {
        scrollY: {
            opacity: [['elInY', 'elCenterY-100'], [0, 1]],
            blur: [['elInY', 'elCenterY-100'], [30, 0]],
            scale: [['elInY', 'elCenterY-100'], [1.4, 1]],
        }
    })


    lax.addElements('.avk-beutel-r', {
        scrollY: {
            translateX: [
                ['elInY-50', 'elCenterY-80'],
                {
                    750: ['-pageWidth', 0],
                    3000: ['pageWidth-elWidth', 0]
                }
            ]
        }
    })

    lax.addElements('.avk-beutel-l', {
        scrollY: { translateX: [['elInY-50', 'elCenterY-80'], ['-pageWidth', 0]] }
    })
});